import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const NothingFound = ({ text, subtext, icon }) => {
  const intl = useIntl();

  return (
    <div className="nothing-found-wrapper">
      <h3>
        {icon && <i className={`${icon} mr-1`} />}
        {text || intl.formatMessage({ defaultMessage: 'Nothing found' })}
      </h3>
      {subtext && (
        <p>{subtext}</p>
      )}
    </div>
  );
};

NothingFound.propTypes = {
  text: PropTypes.string,
  subtext: PropTypes.string,
  icon: PropTypes.string,
};

NothingFound.defaultProps = {
  text: '',
  subtext: null,
  icon: null,
};

export default NothingFound;
